// React/core
import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
    Alert,
    Button,
    Card, CardBody, CardTitle,
    Col,
    FormGroup,
    Row,
} from 'reactstrap';
import {Field, reduxForm} from 'redux-form';
import {Link} from 'react-router';

import {registerUser} from './actions/authentication';

import AuthContainer from './AuthContainer';
import {InputField} from '../../validation/ReduxFormInput';
import RadioButtons from '../../components/controls/buttons/RadioButtons';
import FlowContainer from "./OwnerRegisterFlow/FlowContainer";
import {FormAsyncButton} from "../../components/controls/buttons/AsyncButton";

class RegisterForm extends Component {
    state = {
        user_type: 'tenant',
        error: false
    };

    componentDidMount() {
        document.body.classList.toggle('dark-background', true);
    }

    render() {
        const {error, handleRegister, handleSubmit, pristine, submitting} = this.props;
        return (
            <AuthContainer>
                <Card>
                    <CardBody>
                        <CardTitle className="center">Register with PolyRents</CardTitle>
                        <hr/>
                        <div className="center">
                            <RadioButtons color="primary" onStateChange={(value) => this.setState({user_type: value})} outline>
                                <Button value="tenant">I am a tenant</Button>
                                <Button value="owner">I am an owner</Button>
                                {/*<Button value="contractor">I am a contractor</Button>*/}
                            </RadioButtons>
                        </div>
                        <hr/>
                        {
                            this.state.user_type === 'tenant' ? (
                                <form onSubmit={handleSubmit(handleRegister)}>
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <Field name="first_name" label="First Name" component={InputField} type="text"/>
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <Field name="last_name" label="Last Name" component={InputField} type="text"/>
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <Field name="username" label="Email" component={InputField} type="email"/>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <Field name="password" label="Password" component={InputField} type="password"/>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <Field name="confirm_password" label="Confirm Password" component={InputField} type="password"/>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <FormAsyncButton
                                        type="submit"
                                        color="primary"
                                        acting={submitting}
                                        disabled={pristine}
                                        block
                                        id="tenant_register_button"
                                    >
                                        Sign Up
                                    </FormAsyncButton>
                                    {
                                        error &&
                                        <div className="center" style={{marginTop: '5px'}}>
                                            <Alert color="danger">
                                                {error}
                                            </Alert>
                                        </div>
                                    }
                                </form>
                            ) : (
                                <div>
                                    <FlowContainer/>
                                </div>
                            )
                        }
                        <hr/>
                        <p className="center">
                            Already have an account? <Link to="/login">Sign In</Link>
                        </p>
                    </CardBody>
                </Card>
            </AuthContainer>
        );
    }
}

const validate = (values) => {
    const errors = {};

    !values.first_name && (errors.first_name = 'Required');
    !values.last_name && (errors.last_name = 'Required');
    !values.username && (errors.username = 'Required');
    !values.password && (errors.password = 'Required');
    !values.confirm_password && (errors.confirm_password = 'Required');

    values.password && values.password.length < 8 && (errors.password = 'Password must be at least 8 characters');
    (values.confirm_password !== values.password) && (errors.confirm_password = 'Passwords do not match');

    return errors;
};

RegisterForm = reduxForm({
    form: 'register',
    validate
})(RegisterForm);

const mapStateToProps = (state) => ({
    submitting: state.activeUser.submitting
});

const mapDispatchToProps = (dispatch) => {
    return {
        handleRegister(user) {
            return dispatch(
                registerUser(user)
            );
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterForm);


// WEBPACK FOOTER //
// ./src/containers/authentication/RegisterForm.js